import { LayerDefinition } from './types';

export const aqiDefinition: LayerDefinition = {
  id: 'aqi',
  name: 'Air Quality Index',
  category: 'environment',
  categoryLabel: 'Environmental & Air Quality',
  icon: '🫁',
  description: 'Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.',
  sourceModels: ['gefs', 'raqdps', 'hrrr', 'rrfs', 'AirNow / EPA Station Telemetry'],
  outputModels: ['AQI scale .pmtiles per model', 'Real-time observation markers'],
  config: {
    defaultModel: 'gefs'
  }
};

export default aqiDefinition;
